import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  position:relative;
  width:100%;

  ::-webkit-input-placeholder { /* Edge */
    color: var(--gray-9);
    font-size: 14px;
  }

  :-ms-input-placeholder { /* Internet Explorer 10-11 */
    color: var(--gray-9);
    font-size: 14px;
  }

  ::placeholder {
    color: var(--gray-9);
    font-size: 14px;
  }
`

const Label = styled.label`
  position: absolute;
  top: -18px;
  left: 14px;
  margin: 0px;
  background-color: var(--the-white);
  color: var(--gray-9);
  font-size: 14px;
  font-family: var(--primary-font);
  font-weight: 400;
  padding: 4px;
  z-index: 1;
`

const TextareaStyled = styled.textarea`
  width: 100%;
  height: 88px;
  text-align: left;
  padding: 16px;
  border-radius: var(--Spacing-Spacing-spacing-xxs, 16px);
  border: 1px solid var(--Colors-Neutral-Ink-Light, #777);
  color: var(--gray-5);
  font-size: 14px;
  background-color: var(--the-white);
  display: block;
`

const ErrorMessage = styled.p`
  color: var(--the-red);
  font-size: 13px;
  font-family: var(--primary-font);
  font-weight: 400;
  margin: 0px;
`

const Textarea = ({ id, label, name, onChange, value, isReadOnly, placeholder, onBlur, autoComplete, errorMessage, hookForm }) => {
  const hasError = !!errorMessage
  const textareaProps = {
    id,
    name,
    onChange,
    value,
    readOnly: isReadOnly,
    placeholder,
    onBlur,
    autoComplete,
    ...hookForm
  }

  return (
    <Container>
      {label && (<Label>{label}</Label>)}
      <TextareaStyled {...textareaProps}>{value}</TextareaStyled>
      {hasError && (<ErrorMessage>{errorMessage}</ErrorMessage>)}
    </Container>
  )
}

export default Textarea
